import { render, staticRenderFns } from "./crown.vue?vue&type=template&id=d9f2c192&"
import script from "./crown.vue?vue&type=script&lang=js&"
export * from "./crown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d9f2c192')) {
      api.createRecord('d9f2c192', component.options)
    } else {
      api.reload('d9f2c192', component.options)
    }
    module.hot.accept("./crown.vue?vue&type=template&id=d9f2c192&", function () {
      api.rerender('d9f2c192', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/crown.vue"
export default component.exports